// extracted by mini-css-extract-plugin
export default {"avatarCon":"index_avatarCon__JVI5R","dot":"index_dot__jiZA3","bigDot":"index_bigDot__d+0ko","online":"index_online__oL05o","offline":"index_offline__ztT8E"};